// == Import npm
import React, { useState } from "react";
import { Checkbox, Button, Typography, Collapse } from "antd";
import classNames from "classnames";
import moment from "moment";
import { isEmpty } from "ramda";

// == Import SCSS
import "../meetingPage.less";

// == Import components
import ModalDelete from "./Modal/modalDelete";
import ModalUpdate from "./Modal/modalUpdate";

// == Import icons
import { MdAccessTime, MdDelete, MdEdit } from "react-icons/md";
import { HiPlusCircle, HiMinusCircle } from "react-icons/hi";

// == import i18n
import { useTranslation } from "react-i18next";
import { visitorMatchSearch } from "helpers";

const { Panel } = Collapse;

const ListMeeting = ({
  visits: visit,
  handleCheckVisitor,
  visitorCheck,
  setDisplayButton,
  displayButton,
  user,
  setSearch,
  setVisitorCheck,
  initialSearch,
  currentVisitor,
  searchVisitors,
}) => {
  const [t] = useTranslation();
  const [isDisplay, setIsDisplay] = useState(true);
  const [isModalDeleteVisible, setIsModalDeleteVisible] = useState(false);
  const [isModalUpdateVisible, setIsModalUpdateVisible] = useState(false);

  const toggleDisplay = () => {
    setIsDisplay(!isDisplay);
  };

  if (!isEmpty(visitorCheck)) {
    setDisplayButton(true);
  } else {
    setDisplayButton(false);
  }
  const visitors = visit.visitors;
  const countVisitors = visitors.length;

  const showModalDelete = () => {
    setIsModalDeleteVisible(true);
  };

  const showModalUpdate = () => {
    setIsModalUpdateVisible(true);
  };

  return (
    <>
      <ModalDelete
        isVisible={isModalDeleteVisible}
        setVisible={setIsModalDeleteVisible}
        visit={visit}
        currentVisitor={currentVisitor}
      />
      <ModalUpdate
        isVisible={isModalUpdateVisible}
        setVisible={setIsModalUpdateVisible}
        user={user}
        setSearch={setSearch}
        setVisitorCheck={setVisitorCheck}
        initialSearch={initialSearch}
        visit={visit}
      />

      <Collapse bordered={false}>
        <Panel
          showArrow={false}
          header={
            <>
              <MdAccessTime
                style={{ marginRight: "10px", fontSize: "27px", verticalAlign: "-5px" }}
              />
              {t("VisitOf")} {moment(visit.startDate).format("HH:mm")}
            </>
          }
          extra={
            <>
              <Button
                onClick={() => {
                  showModalUpdate();
                  window.scrollTo(0, 0);
                }}
                icon={<MdEdit style={{ fontSize: "21px" }} />}
                style={{
                  backgroundColor: "transparent",
                  boxShadow: "none",
                  marginRight: "10px",
                  border: "none",
                }}
                type="primary"
              ></Button>
              <Button
                onClick={() => {
                  showModalDelete();
                  window.scrollTo(0, 0);
                }}
                icon={<MdDelete style={{ fontSize: "21px" }} />}
                style={{
                  backgroundColor: "transparent",
                  boxShadow: "none",
                  border: "none",
                }}
                type="primary"
              ></Button>
            </>
          }
        >
          <div className="meetingPage__listMeeting__section__checkbox">
            {visitors.map((visitor, index) => {
              return (
                <Checkbox
                  key={index}
                  className={classNames("meetingPage__listMeeting__section__checkbox__hide", {
                    "meetingPage__listMeeting__section__checkbox__hide--display":
                      index <= 2 || !isDisplay,
                  })}
                  checked={visitorCheck.find(v => v.id === visitor.id)}
                  onChange={e =>
                    handleCheckVisitor(e.target.checked, visitor, visit.id, visit.resident)
                  }
                >
                  <Typography.Paragraph
                    strong
                    style={{
                      fontSize: "20px",
                      margin: "20px 0 0 20px",
                      overflowWrap: "breack-word",
                    }}
                  >
                    {visitor.firstname} {visitor.lastname}
                  </Typography.Paragraph>
                  <Typography.Paragraph
                    style={{
                      fontSize: "18px",
                      margin: "10px 0 0 20px",
                      overflowWrap: "breack-word",
                    }}
                  >
                    {visitor.company}
                  </Typography.Paragraph>
                  <Typography.Paragraph
                    italic
                    style={{
                      fontSize: "18px",
                      margin: "10px 0 10px 20px",
                      overflowWrap: "breack-word",
                    }}
                  >
                    {visitor.phone}
                  </Typography.Paragraph>
                  {visitor.durationInDay > 1 && (
                    <Typography.Paragraph
                      italic
                      style={{
                        fontSize: "16px",
                        margin: "10px 0 10px 20px",
                        overflowWrap: "breack-word",
                      }}
                    >
                      {t("InVisitUntil") +
                        " " +
                        moment(visitor.endDayVisit).format(t("formatDate"))}
                    </Typography.Paragraph>
                  )}
                  <Typography.Paragraph
                    className={
                      "meetingPage__listMeeting__section__checkbox__state--" + visitor.status
                    }
                  >
                    {t(visitor.status)}
                  </Typography.Paragraph>
                </Checkbox>
              );
            })}
            {visitors.length <= 3 ? null : isDisplay ? (
              <Button
                className="meetingPage__listMeeting__section__checkbox__more"
                onClick={toggleDisplay}
                style={{
                  borderRadius: "0px",
                  minHeight: "150px",
                  flexFlow: "wrap column",
                  textAlign: "center",
                  border: "none",
                  display: "flex",
                }}
                type="default"
              >
                <Typography.Paragraph
                  strong
                  style={{ margin: "0", textTransform: "uppercase", fontSize: "20px" }}
                >
                  {t("more")} <HiPlusCircle style={{ verticalAlign: "-3px" }} />
                </Typography.Paragraph>
                <Typography.Paragraph italic>
                  {countVisitors === 1
                    ? `(+ ${countVisitors} ${t("Personn")})`
                    : `(+ ${countVisitors} ${t("Personns")})`}
                </Typography.Paragraph>
              </Button>
            ) : (
              <Button
                className="meetingPage__listMeeting__section__checkbox__more"
                onClick={toggleDisplay}
                style={{
                  borderRadius: "0px",
                  minHeight: "150px",
                  flexFlow: "wrap column",
                  textAlign: "center",
                  border: "none",
                  display: "flex",
                }}
                type="default"
              >
                <Typography.Paragraph
                  strong
                  style={{ margin: "0", textTransform: "uppercase", fontSize: "20px" }}
                >
                  {t("less")} <HiMinusCircle style={{ verticalAlign: "-3px" }} />
                </Typography.Paragraph>
                <Typography.Paragraph className="meetingPage__listMeeting__section__checkbox__more__number">
                  {countVisitors === 1
                    ? `(- ${countVisitors} ${t("Personn")})`
                    : `(- ${countVisitors} ${t("Personns")})`}
                </Typography.Paragraph>
              </Button>
            )}
          </div>
        </Panel>
      </Collapse>
    </>
  );
};

export default ListMeeting;
